import { render, staticRenderFns } from "./GreenChannel.vue?vue&type=template&id=1380ff4c&scoped=true"
import script from "./GreenChannel.vue?vue&type=script&lang=js"
export * from "./GreenChannel.vue?vue&type=script&lang=js"
import style0 from "./GreenChannel.vue?vue&type=style&index=0&id=1380ff4c&prod&scoped=true&lang=css"
import style1 from "./GreenChannel.vue?vue&type=style&index=1&id=1380ff4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380ff4c",
  null
  
)

export default component.exports